module.exports = __webpack_public_path__ + "img/go.51050fef.png";